export default "__VITE_ASSET__80c15a4b__"